export const ACCEPT_THE_JOB = "ACCEPT_THE_JOB"
export const REJECT_THE_JOB = "REJECT_THE_JOB"
export const REVERSE_THE_DECISION = "REVERSE_THE_DECISION"
export const ADD_THE_CANDIDATE = "ADD_THE_CANDIDATE"